import { useCallback } from 'react';
import { toast } from 'sonner';
import { useAdminOrg } from '@/hooks/useAdminOrg';
import { READ_ONLY_MESSAGE } from '@/lib/platformReadOnlyBoundary';

/** Shared handler-level policy for every tenant-admin mutation. */
export function useReadOnlyGuard() {
  const { canWrite } = useAdminOrg();

  const assertCanWrite = useCallback((): boolean => {
    if (canWrite) return true;
    toast.error(READ_ONLY_MESSAGE);
    return false;
  }, [canWrite]);

  const guardWrite = useCallback(<T extends unknown[]>(handler: (...args: T) => void | Promise<void>) => {
    return (...args: T) => {
      if (!assertCanWrite()) return;
      return handler(...args);
    };
  }, [assertCanWrite]);

  return { canWrite, assertCanWrite, guardWrite, readOnlyMessage: READ_ONLY_MESSAGE };
}
